import { Fighter } from "../types";

const warband: Fighter[] = [
  {
    name: "Heart-eater",
    faction: { type: "UNTAMED_BEASTS" },
    points: 180,
    movement: 5,
    toughness: 4,
    wounds: 20,
    runemarks: {
      0: { type: "LEADER" },
    },
    weapons: {
      0: {
        type: "AXE",
        min_range: 0,
        max_range: 1,
        attacks: 4,
        strength: 4,
        base_damage: 2,
        critical_damage: 5,
      },
    },
  },
  {
    name: "First Fang",
    faction: { type: "UNTAMED_BEASTS" },
    points: 140,
    movement: 4,
    toughness: 4,
    wounds: 15,
    runemarks: {
      1: { type: "BRUTE" },
    },
    weapons: {
      0: {
        type: "SPEAR",
        min_range: 0,
        max_range: 8,
        attacks: 2,
        strength: 4,
        base_damage: 2,
        critical_damage: 5,
      },
      1: {
        type: "AXE",
        min_range: 0,
        max_range: 1,
        attacks: 3,
        strength: 4,
        base_damage: 1,
        critical_damage: 4,
      },
    },
  },
  {
    name: "Beastspeaker",
    faction: { type: "UNTAMED_BEASTS" },
    points: 125,
    movement: 4,
    toughness: 4,
    wounds: 15,
    runemarks: {
      0: { type: "AGILE" },
    },
    weapons: {
      0: {
        type: "REACH_WEAPON",
        min_range: 0,
        max_range: 4,
        attacks: 4,
        strength: 4,
        base_damage: 1,
        critical_damage: 2,
      },
      1: {
        type: "DAGGER",
        min_range: 0,
        max_range: 1,
        attacks: 3,
        strength: 4,
        base_damage: 1,
        critical_damage: 4,
      },
    },
  },
  {
    name: "Rocktusk Prowler",
    faction: { type: "UNTAMED_BEASTS" },
    points: 180,
    movement: 8,
    toughness: 4,
    wounds: 20,
    runemarks: {
      0: { type: "BEAST" },
    },
    weapons: {
      0: {
        type: "FANGS",
        min_range: 0,
        max_range: 1,
        attacks: 4,
        strength: 4,
        base_damage: 2,
        critical_damage: 5,
      },
    },
  },
  {
    name: "Preytaker with Fanged Axe",
    faction: { type: "UNTAMED_BEASTS" },
    points: 105,
    movement: 4,
    toughness: 4,
    wounds: 10,
    runemarks: {},
    weapons: {
      0: {
        type: "AXE",
        min_range: 0,
        max_range: 1,
        attacks: 3,
        strength: 4,
        base_damage: 2,
        critical_damage: 4,
      },
    },
  },
  {
    name: "Preytaker with Sawtooth Blade",
    faction: { type: "UNTAMED_BEASTS" },
    points: 105,
    movement: 4,
    toughness: 4,
    wounds: 10,
    runemarks: {},
    weapons: {
      0: {
        type: "SWORD",
        min_range: 0,
        max_range: 1,
        attacks: 4,
        strength: 3,
        base_damage: 2,
        critical_damage: 4,
      },
    },
  },
  {
    name: "Plains-runner",
    faction: { type: "UNTAMED_BEASTS" },
    points: 55,
    movement: 5,
    toughness: 3,
    wounds: 8,
    runemarks: {},
    weapons: {
      0: {
        type: "AXE",
        min_range: 0,
        max_range: 1,
        attacks: 3,
        strength: 3,
        base_damage: 1,
        critical_damage: 3,
      },
    },
  },
];

export default warband;
